<template>
  <div class="header-wrapper">
    <h2 class="header">
      <icon-font v-if="icon" :name="icon" class="header__icon" />
      <span :style="titleStyle" class="header__title">{{ title }}</span>
    </h2>
    <slot name="related-links"></slot>
  </div>
</template>

<script>
import IconFont from "@/mikan/_shared/components/atoms/icons/IconFont.vue";

export default {
  components: { IconFont },
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    titleStyle: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';
@import '~@/mikan/_shared/fonts/iconfont';

.header-wrapper {
  position: relative;
  border-bottom: 1px dashed $color-navy-20;
  color: $color-orange;

  @include for-tb-pc {
    padding: 18px 0;

    &::before {
      position: absolute;
      top: 0;
      display: block;
      width: 100%;
      height: 4px;
      background-color: $color-orange;
      border-radius: 999em;
      content: '';
    }
  }
}

.header {
  display: flex;
  align-items: center;
  @include for-sp {
    padding: 9px;
  }

  &__icon {
    width: 32px;
    height: 32px;
    margin-left: 4px;
    color: $color-orange;
    font-size: px-to-rem(32px);

    &:nth-child(n + 2) {
      margin-left: 32px;
    }
  }

  &__title {
    font-size: px-to-rem(28px);
    font-weight: bold;

    @include for-sp {
      font-size: px-to-rem(26px);
    }

    &:nth-child(n + 2) {
      margin-left: 18px;

      @include for-sp {
        margin-left: 6px;
      }
    }
  }
}
</style>
